import { Controls, useEdgesState, useNodesState } from 'reactflow';
import { SchemaDataModel } from './types';
import { useCallback, useEffect, useMemo } from 'react';
import DimensionNode from './DimensionNode';
import FactNode from './FactNode';
import { StyledReactFlow } from './SchemaEntityRelationsUI';
import { useAppSelector } from '../../../../redux/hooks';
import { dataModelerSelectCurrentDraftEdits } from '../../../../redux/selectors/dataModeler';
import { applySchemaEdits, calculateInitialNodes } from './utils';
import { DataModelerTabPanel } from '../DataModelerCommonUI';

interface IProps {
  dataModel: SchemaDataModel;
}

const nodeTypes = {
  factNode: FactNode,
  dimensionNode: DimensionNode,
};

const SchemaEntityRelations = ({ dataModel }: IProps) => {
  const draftEdits = useAppSelector(dataModelerSelectCurrentDraftEdits);
  const updatedDataModel = useMemo(() => {
    return applySchemaEdits(dataModel, draftEdits);
  }, [dataModel, draftEdits]);

  const [initialNodes, initialEdges] = useMemo(
    () => calculateInitialNodes(updatedDataModel),
    [updatedDataModel],
  );

  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const resetState = useCallback(() => {
    setNodes(initialNodes);
    setEdges(initialEdges);
  }, [initialNodes, initialEdges, setNodes, setEdges]);

  // Have to recalculate everything on schema key change
  useEffect(() => {
    resetState();
  }, [dataModel.key, resetState]);

  return (
    <DataModelerTabPanel>
      <StyledReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        nodeTypes={nodeTypes}
        fitView
      >
        <Controls>
          <button
            type="button"
            title={'Reset'}
            className={'react-flow__controls-button'}
            onClick={resetState}
          >
            R
          </button>
        </Controls>
      </StyledReactFlow>
    </DataModelerTabPanel>
  );
};

export default SchemaEntityRelations;
